// Lightweight GA4 event helper. Fires only when gtag is present (loaded in index.html)
// and never throws — safe to call from any component.
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    /* no-op */
  }
}
